const isLocalhost =
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1";

// Google's official test keys (always pass, any domain)
const TEST_RECAPTCHA_SITEKEY = "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI";
const PROD_RECAPTCHA_SITEKEY = "6LcH1_UnAAAAAHFTYqOMYpnwi-5255VZRD7JcsA_";

export const RECAPTCHA_SITEKEY = isLocalhost
  ? TEST_RECAPTCHA_SITEKEY
  : PROD_RECAPTCHA_SITEKEY;
